import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';


export default {
  __name: 'Datepicker',
  setup(__props) {

const format = (date) => {
    const d = new Date(date);
    const month = `${d.getMonth() + 1}`.padStart(2, '0');
    const day = `${d.getDate()}`.padStart(2, '0');
    const year = d.getFullYear();

    return `${day}.${month}.${year}`;
};

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(_unref(Datepicker), _mergeProps(_ctx.$attrs, {
    locale: "pl",
    required: "",
    "auto-apply": "",
    "close-on-auto-apply": true,
    format: format,
    "enable-time-picker": false,
    clearable: false
  }), null, 16))
}
}

}